const LocalStorage = {
  mounted() {
    this.localStorageKey = this.el.dataset.localStorageKey;
    this.loadEvent = this.el.dataset.loadEvent;
    this.payloadKeyOnLoad = this.el.dataset.payloadKeyOnLoad;
    this.payloadKeyOnStore = this.el.dataset.payloadKeyOnStore;

    if (!this.localStorageKey) {
      console.error("LocalStorage: data-local-storage-key is required.");
      return;
    }

    // Load data from localStorage and push to server
    if (this.loadEvent && this.payloadKeyOnLoad) {
      const storedValue = localStorage.getItem(this.localStorageKey);
      // Check if storedValue is not null, not an empty string, and not an empty array string "[]"
      if (storedValue && storedValue !== "" && storedValue !== "[]") {
        try {
          const parsedValue = JSON.parse(storedValue);
          this.pushEvent(this.loadEvent, { [this.payloadKeyOnLoad]: parsedValue });
        } catch (e) {
          console.error("LocalStorage: Failed to parse stored JSON for load event.", e);
          // Potentially corrupted data, clear it
          localStorage.removeItem(this.localStorageKey);
        }
      }
    } else if (this.loadEvent && !this.payloadKeyOnLoad) {
        console.warn("LocalStorage: data-load-event is present, but data-payload-key-on-load is missing. No data will be pushed for event:", this.loadEvent);
    }

    // Listen for event from server to store data
    if (this.payloadKeyOnStore) {
      this.handleEvent("store", (payload) => {
        const dataToStore = payload[this.payloadKeyOnStore];
        const valueInLocalStorage = localStorage.getItem(this.localStorageKey);

        let shouldStore = false;
        if (dataToStore !== undefined && dataToStore !== null) {
          if (Array.isArray(dataToStore)) {
            shouldStore = dataToStore.length > 0;
          } else if (typeof dataToStore === 'string') {
            shouldStore = dataToStore !== "";
          } else {
            // For non-array, non-string types (objects, numbers, booleans),
            // store them if they are present (not null/undefined).
            shouldStore = true;
          }
        }

        if (shouldStore) {
          try {
            const stringifiedData = JSON.stringify(dataToStore);
            // Only update if data has actually changed to avoid unnecessary localStorage writes
            if (stringifiedData !== valueInLocalStorage) {
              localStorage.setItem(this.localStorageKey, stringifiedData);
            }
          } catch (e) {
            console.error("LocalStorage: Failed to stringify data for store event.", e);
          }
        } else {
          // If dataToStore is null, undefined, empty array, or empty string, remove from localStorage
          if (valueInLocalStorage !== null) {
            localStorage.removeItem(this.localStorageKey);
          }
        }
      });
    }
  },
};

export default LocalStorage;
